import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import technicianService from '../../api/technicianService';
import useAuth from '../../hooks/useAuth';
import { useNotifications } from '../../context/NotificationContext';
import LoadingSpinner from '../common/LoadingSpinner';
import BookingCard from '../common/BookingCard';
import StarRating from '../common/StarRating';
import EmptyState from '../common/EmptyState';
import { rating } from '../../utils/formatters';

export default function TechnicianDashboard() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const notify = useNotifications();
  const [data, setData] = useState(null);

  useEffect(() => {
    technicianService.getDashboard().then(setData).catch((e) => notify.apiError(e));
  }, [notify]);

  if (!data) return <div className="page"><div className="container"><LoadingSpinner /></div></div>;
  const p = data.profile;
  const pending = user?.status === 'PENDING';

  return (
    <div className="page">
      <div className="container stack" style={{ gap: '1.5rem' }}>
        <div className="page-head">
          <div>
            <h1>{p.firstName} {p.lastName}</h1>
            <p>{p.technicianTypeName}</p>
          </div>
          <Link to="/technician/profile" className="btn ghost">{t('technician.editProfile')}</Link>
        </div>

        {pending && (
          <div className="alert warn">
            <Trans i18nKey="technician.accountPending" components={{ 1: <strong /> }} />
          </div>
        )}

        <div className="grid stats">
          <div className="stat"><div className="n">{data.pendingBookings}</div><div className="l">{t('technician.pendingRequests')}</div></div>
          <div className="stat"><div className="n">{data.upcomingBookings}</div><div className="l">{t('technician.upcomingJobs')}</div></div>
          <div className="stat"><div className="n">{data.completedBookings}</div><div className="l">{t('technician.completed')}</div></div>
          <div className="stat">
            <div className="n">{rating(data.averageRating)}</div>
            <div className="l">{t('technician.rating')} · {data.totalReviews} {t('common.reviews')}</div>
          </div>
        </div>

        <div className="card pad spread">
          <span><StarRating value={data.averageRating} /> {rating(data.averageRating)}</span>
          <Link to="/technician/reviews">{t('technician.reviewsTitle')}</Link>
        </div>

        <div>
          <div className="spread" style={{ marginBottom: '.75rem' }}>
            <h2>{t('technician.recentJobs')}</h2>
            <Link to="/technician/bookings">{t('common.all')}</Link>
          </div>
          {data.recentBookings?.length ? (
            <div className="stack">
              {data.recentBookings.map((b) => (
                <BookingCard key={b.id} booking={b} perspective="technician" />
              ))}
            </div>
          ) : (
            <EmptyState icon="briefcase" title={t('technician.noJobs')} />
          )}
        </div>
      </div>
    </div>
  );
}
